
<template>
    <!-- <input
      id="datepicker"
      class="form-control form-control-sm"
      type="text"
      @focus="selectAll"
      :value="lData"
      @input="updateValue($event.target.value)"
      ref="data"
      data-toggle="date"
      @keyup.enter="focusControl()"> -->


    <!-- <input
      class="date"
      type="date"
      @focus="selectAll"
      :value="lData"
      @input="updateValue($event.target.value)"
      ref="data"
      @keyup.enter="focusControl()"> -->

    <date-picker ref="data" :value="lData" :config="options" @input="updateValue($event)" v-on:keyup=""></date-picker>
</template>

<script>
import { SysVars } from '../main'
import datePicker from 'vue-bootstrap-datetimepicker'
import { formatDate, hasHiddenParent } from '../shared/utils'

export default {
    props: {
      value: { String },
    },

    components: {
      datePicker
    },

    data () {
      var self = this;
      return {
        lData: this.value,
        focused: false,
        options: {
          format: 'DD-MM-YYYY',
          useCurrent: false,
          locale: 'pt',
          showClear: true,
          showClose: true,
          icons: {
            time: 'fa fa-clock',
            date: 'fa fa-calendar',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-chevron-left',
            next: 'fa fa-chevron-right',
            today: 'fa fa-calendar-check',
            clear: 'fa fa-trash',
            close: 'fa fa-times-circle'
          },
          keyBinds: {
            enter: function (e) {
              this.hide();
              self.focusControl(e)
              return false



            }
          }
        }
      }
    },

    mounted () {
      this.formatValue(this.value)

      jQuery(".datepicker").attr("autocomplete", "off");
    },

	  computed: {

    },

    created () {

    },

    methods: {
      updateValue: function(value) {
        if (value) {
          const [day_, month_, year_] = value.split("-")
          let d = [year_, month_, day_].join('-')
          this.$emit('input', d)
        } else {
          this.$emit('input', value)
        }

      },

      selectAll: function(event) {
        this.focused = true
        // Workaround for Safari bug
        // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
        setTimeout(function() {
          event.target.select()
        }, 0)
      },

      formatValue: function (value) {
        //recebe um valor yyyy-mm-dd e converte em dd-mm-yyyy
        if (value)
          jQuery(this.$el)[0].value = formatDate(value)

        // if (!checkDate(value))
        //   return
        // console.log('aqui ' + value)
        // const [year_, month_, day_] = value.split("-")
        // jQuery(this.$el)[0].value = [day_, month_, year_].join('-')

        // function pad(s) { return (s < 10) ? '0' + s : s; }
        // var d = new Date(value)
        // jQuery(this.$el)[0].value = [pad(d.getDate()+1), pad(d.getMonth()+1), d.getFullYear()].join('-')
      },

      focusControl: function (event) {
          var thisIndex = jQuery(this.$el).index(SysVars.sFocusControl)
          var next = thisIndex + 1
          var obj = jQuery(SysVars.sFocusControl)
          let found = false
          for (var x = next; x < obj.length; x++) {
            if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
              jQuery(obj[x]).focus()
              found = true
              break
            }
          }
          if (!found) {
            for (var x = 0; x < obj.length; x++) {
              if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
                jQuery(obj[x]).focus()
                found = true
                break
              }
            }
          }

          this.$emit('keyenter')
      },

      focus: function () {
          if (this.$refs.data) {
              jQuery(this.$el)[0].focus()
          }
      },

    },
    watch: {
      value: function (value) {
        if (!this.focused) {
          this.formatValue(value)
        }
      }
    }


}
</script>

<style scoped>
  input {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/input-date.vue